import React, {Component} from 'react';
import {Button, Modal, Form, Card} from 'semantic-ui-react';
import Alert from "../../components/extras/Alert";

let styles = {
    parent: {
        display: 'flex',
        paddingTop: 20
    },
    child: {
        margin: 'auto'
    }
};

class ImageUploadDialog extends Component {
    constructor() {
        super();

        this.state = {
            open: false,
            id: '',
            file: null,
            image: null,
            loading: false
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.openFileDialog = this.openFileDialog.bind(this);
    }

    handleClose = () => {
        this.setState({id: '', file: null, image: null, open: false, loading: false});
    };

    handleOpen = (id) => {
        this.setState({open: true, id: id, loading: false});
    };

    handleSubmit(e) {
        e.preventDefault();
        if (this.state.image) {
            this.props.callbackLoadImage(this.state.image);
            this.setState({loading: true});
        }else{
            this.refs.alert.open({message:'Selecciona una imagen!', type:'error'});
        }
    }

    handleImageChange(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({file: file, image: reader.result});
        };
        reader.readAsDataURL(file)
    }

    openFileDialog() {
        this.refs.fileUpload.click();
    }

    render() {
        let {image} = this.state;
        let imagePreview = null;
        if (image) {
            imagePreview = (<Card raised image={image} style={styles.child} height='120'/>);
        }

        return (
            <Modal size='tiny' open={this.state.open} onClose={this.handleClose} dimmer='inverted'>
                <Modal.Header>{this.props.title}</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Button fluid onClick={this.openFileDialog}>Seleccionar Imagen</Button>
                        <Form onSubmit={this.handleSubmit}>
                            <input
                                ref="fileUpload"
                                type="file"
                                style={{"display": "none"}}
                                accept=".png, .jpg, .jpeg"
                                onChange={this.handleImageChange}
                            />
                        </Form>
                        <div style={styles.parent}>
                            {imagePreview}
                        </div>
                        <Alert ref='alert'/>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button icon='x' labelPosition='left' onClick={this.handleClose} content='Cerrar'/>
                    <Button primary icon='upload' loading={this.state.loading} active={this.state.loading}
                            labelPosition='left' onClick={this.handleSubmit} content='Si, subir esta imagen!'/>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default ImageUploadDialog;



// WEBPACK FOOTER //
// ./src/components/extras/ImageUploadDialog.js